(function ($) {
  "use strict";

  // Order must match the tbody rows rendered in template.php
  var FEE_KEYS = ["statutory", "admin", "hospital", "nominal", "niisq"];

  $(function () {
    $(".qld__fee-lookup select").on("change", function () {
      var $select  = $(this);
      var $wrapper = $select.closest(".qld__fee-lookup");
      var $results = $wrapper.find(".qld__fee-lookup__results");
      var index    = $select.val();

      if (index === "") {
        $results.attr("hidden", "");
        return;
      }

      var feeData;
      try {
        feeData = JSON.parse($select.attr("data-fee-data"));
      } catch (e) {
        return;
      }

      var item = feeData[parseInt(index, 10)];
      if (!item) {
        return;
      }

      // Update table title (targets the h2 rendered by block-table)
      $results.find(".qld__table h2").text(
        "Levy Summary " + " \u2013 Class " + item["class"]
      );

      // Populate fee cells by row index and accumulate total
      var total = 0;
      var $rows = $results.find("tbody tr");
      $.each(FEE_KEYS, function (i, key) {
        var num = parseFloat(item[key]);
        var $cell = $rows.eq(i).find("td").last();
        if (!isNaN(num)) {
          $cell.text("$" + num.toFixed(2));
          total += num;
        } else {
          $cell.text("\u2014");
        }
      });

      // Update total cell in tfoot
      $results.find("tfoot td").last().text("$" + total.toFixed(2));

      $results.removeAttr("hidden");
    });

    // Select the first item by default now that the handler is registered
    $(".qld__fee-lookup select").each(function () {
      var $select = $(this);
      var $first = $select.find("option:not([value=''])").first();
      if ($first.length) {
        $first.prop("selected", true);
        $select.trigger("change");
      }
    });
  });
})(jQuery);
